import { Button } from "react-bootstrap";
import classNames from "classnames";

import { FontFa } from "../../../../../components";
import { DateHelper, StringHelper } from "../../../../../helper";

import * as docx from "docx";
import { saveAs } from "file-saver";
import { getWordValue } from "../utils";
import { DocumentAFLCreator } from "../services";
import { AFLType } from "../models";
import { useAFLSteps } from "./use-AFL-steps";
import { useSearchColumn } from "./use-search-column";

const getWordTitle = (type: AFLType) => {
  switch (type) {
    case AFLType.AFLNoSalary:
      return "ĐƠN XIN NGHỈ KHÔNG LƯƠNG";
    case AFLType.AFLSuspendContract:
      return "ĐƠN XIN TẠM HOÃN HỢP ĐỒNG LAO ĐỘNG";
    case AFLType.AccidentLeaveApplication:
      return "ĐƠN XIN NGHỈ TAI NẠN RỦI RO /TAI NẠN GIAO THÔNG/ĐIỀU TRỊ BỆNH NGHỀ NGHIỆP/BỆNH DÀI NGÀY";
    case AFLType.AccidentNotification:
      return "THÔNG BÁO TAI NẠN RỦI RO/TAI NẠN GIAO THÔNG";
    case AFLType.ApplicationForLeave:
      return "ĐƠN XIN NGHỈ PHÉP";
    case AFLType.MaternityLeaveApplication:
      return "THÔNG BÁO V/V NGHỈ THAI SẢN";
    case AFLType.SickLeaveApplication:
      return "ĐƠN XIN NGHỈ ỐM/NUÔI CON ỐM";
    case AFLType.TerminationContractApplication:
      return "ĐƠN XIN CHẤM DỨT HỢP ĐỒNG LAO ĐỘNG";
    default:
      return "";
  }
};

export const useAFLColumns = () => {
  const { process } = useAFLSteps();
  const { getSearchTextColumnProperties, getSearchCalendarColumnProperties } =
    useSearchColumn();
  const columns: any[] = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 140,
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "id",
      }),
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => (
        <span>{DateHelper.formatDateToString(text)}</span>
      ),
      ...getSearchCalendarColumnProperties({
        dataIndex: "createdDateTime",
        inputSearchProps: { placeholder: "Tìm kiếm" },
      }),
    },
    {
      title: "Mã nhân viên",
      dataIndex: "eEmployeeId",
      key: "eEmployeeId",
      align: "center" as const,
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eEmployeeId",
      }),
    },
    {
      title: "Tên người nghỉ",
      dataIndex: "eRequestName",
      key: "eRequestName",
      align: "center" as const,
      render: (text: string) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eRequestName",
      }),
    },
    {
      title: "Đội/Nhóm",
      key: "eTeam",
      dataIndex: "eTeam",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eTeam",
      }),
    },
    {
      title: "Đơn vị",
      key: "eUnit",
      dataIndex: "eUnit",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eUnit",
      }),
    },
    {
      title: "Cơ quan/Đơn vị",
      key: "eDepartment",
      dataIndex: "eDepartment",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eDepartment",
      }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      align: "center" as const,
      width: 120,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: "Đang đợi duyệt",
        },
        {
          text: "Đã duyệt",
          value: "Đã duyệt",
        },
        {
          text: "Đã hoàn tất",
          value: "Đã hoàn tất",
        },
        {
          text: "Đã từ chối",
          value: "Đã từ chối",
        },
        {
          text: "Đã huỷ",
          value: "Đã huỷ",
        },
      ],
      onFilter: (value: string, record: any) => {
        const { status } = process({
          steps: record?.eSteps,
          current: record.eApprovalProcess.current,
          eRequestStatus: record.eRequestStatus,
        });
        return status.label.startsWith(value);
      },
      render: (_: string, record: any) => {
        const { status } = process({
          steps: record?.eSteps,
          current: record.eApprovalProcess.current,
          eRequestStatus: record.eRequestStatus,
        });
        return (
          <div className={classNames("flag", status.flag)}>{status.label}</div>
        );
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title={"Xuất file"}
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const documentAFLCreator = new DocumentAFLCreator();
            const value = getWordValue(record);

            const doc = documentAFLCreator.create(value);

            const wordTitle = `${getWordTitle(
              value.aflType
            )} - ${DateHelper.getNow()}.docx`;

            docx.Packer.toBlob(doc).then((blob) => {
              saveAs(blob, wordTitle);
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  const columns2: any[] = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 140,
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "id",
      }),
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => (
        <span>{DateHelper.formatDateToString(text)}</span>
      ),
      ...getSearchCalendarColumnProperties({
        dataIndex: "createdDateTime",
        inputSearchProps: { placeholder: "Tìm kiếm" },
      }),
    },
    {
      title: "Mã nhân viên",
      dataIndex: "eEmployeeId",
      key: "eEmployeeId",
      align: "center" as const,
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eEmployeeId",
      }),
    },
    {
      title: "Tên người nghỉ",
      dataIndex: "eRequestName",
      key: "eRequestName",
      align: "center" as const,
      render: (text: string) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eRequestName",
      }),
    },
    {
      title: "Đội/Nhóm",
      key: "eTeam",
      dataIndex: "eTeam",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eTeam",
      }),
    },
    {
      title: "Đơn vị",
      key: "eUnit",
      dataIndex: "eUnit",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eUnit",
      }),
    },
    {
      title: "Cơ quan/Đơn vị",
      key: "eDepartment",
      dataIndex: "eDepartment",
      render: (text: string) => (
        <span>{StringHelper.verticalBarSplit(text)[1]}</span>
      ),
      ...getSearchTextColumnProperties({
        inputSearchProps: { placeholder: "Tìm kiếm" },
        dataIndex: "eDepartment",
      }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      align: "center" as const,
      width: 120,
      render: (_: string, record: any) => {
        const { status } = process({
          steps: record?.eSteps,
          current: record.eApprovalProcess.current,
          eRequestStatus: record.eRequestStatus,
        });
        return (
          <div className={classNames("flag", status.flag)}>{status.label}</div>
        );
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title={"Xuất file"}
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const documentAFLCreator = new DocumentAFLCreator();
            const value = getWordValue(record);

            const doc = documentAFLCreator.create(value);

            const wordTitle = `${getWordTitle(
              value.aflType
            )} - ${DateHelper.getNow()}.docx`;

            docx.Packer.toBlob(doc).then((blob) => {
              saveAs(blob, wordTitle);
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];

  return { columns, columns2 };
};
